module.exports = __webpack_public_path__ + "static/media/iconTarget2.16be48e5.svg";